/**
 * Chat/list tag-dot order: active matching workspaces in front, extra tags behind.
 */

export const WORKSPACE_TAG_STACK_MAX = 3

export type WorkspaceTagDot = {
  id: string
  name: string
  color: string | null
}

type WorkspaceTagSource = {
  id: string
  name: string
  color: string | null
}

/**
 * Front-first order for overlapping tag dots.
 * Active tagged workspaces eclipse inactive tags (e.g. Personal in front of FlowNotes Product).
 * When the sidebar is unfiltered, keep stored tag order.
 */
export function orderTaggedWorkspacesForList(
  taggedIds: string[],
  workspaces: WorkspaceTagSource[],
  activeIds: string[],
): WorkspaceTagDot[] {
  const byId = new Map(workspaces.map((w) => [w.id, w]))
  const seen = new Set<string>()
  const ordered: WorkspaceTagDot[] = []

  const push = (id: string) => {
    if (seen.has(id)) return
    const w = byId.get(id)
    if (!w) return
    seen.add(id)
    ordered.push({ id: w.id, name: w.name, color: w.color })
  }

  if (activeIds.length > 0) {
    for (const id of activeIds) {
      if (taggedIds.includes(id)) push(id)
    }
  }

  for (const id of taggedIds) {
    push(id)
  }

  return ordered
}
